export class ChatBotSummary {
    constructor( public summary: string ) {}
}

